import React from 'react'
export default function CreateCouponPage() {
  return <div><h1 className="text-2xl font-bold">Create Coupon</h1></div>
}
